import React from 'react';
import './TagGroup.css';

interface TagGroupProps {
    type?: 'em-c-tags--light' | 'em-c-tags--outlined';
    color?:
        | 'em-c-tags__theme-red'
        | 'em-c-tags__theme-blue'
        | 'em-c-tags__theme-plum'
        | 'em-c-tags__theme-violet'
        | 'em-c-tags__theme-seablue'
        | 'em-c-tags__theme-green'
        | 'em-c-tags__theme-orange';
    closing?: boolean;
    optionalClass?: string;
    children?: React.ReactNode;
}

const TagGroup: React.FC<TagGroupProps> = ({
    type,
    color,
    closing,
    optionalClass,
    children,
}) => {
    const className = [
        'em-c-tags',
        type,
        color,
        closing ? 'em-c-tags--closing' : '',
        optionalClass || '',
    ]
        .filter(Boolean)
        .join(' ');

    return <ul className={className}>{children}</ul>;
};

export default TagGroup;